<template>
  <Card :name="config.variableFullName">
    <template v-slot:header>
      <h4 class="card-title">
        {{ config.variableFullName }}
      </h4>

      <h3 class="card-title">
        <i
          class="fa"
          :class="[config.icon, getIconColorClass()]"
          aria-hidden="true"
          style="font-size: 30px"
        ></i>
        <span class="mx-2"
          >{{ value.toFixed(config.decimalPlaces) }} {{ config.unit }}</span
        >
      </h3>
    </template>
    <div>
      <i class="pull-right"
        >{{ config.maxValue.toFixed(config.decimalPlaces) || 100 }}
        {{ config.unit }}</i
      >
      <i class="pull-left"
        >{{ config.minValue.toFixed(config.decimalPlaces) || 0 }}
        {{ config.unit }}</i
      >
      <VueSlider
        class="mt-2"
        v-model="setValue"
        :tooltip="true"
        :min="config.minValue"
        :max="config.maxValue"
        :height="14"
        :color="updateColorClass()"
        track-color="#e0e0e0"
        :handle-scale="1.9"
        :alwaysShowHandle="true"
        :step="getStep()"
        :format-tooltip="formatTooltip"
        @drag-end="sendValue"
      />
      <p class="text-center mt-4">
        Actual: {{ setValue.toFixed(config.decimalPlaces) }} {{ config.unit }}
      </p>
    </div>
  </Card>
</template>

<script>
import emitter from "@/eventBus";
import VueSlider from "vue3-slider";
export default {
  name: "iotswitch",
  props: ["config"],
  components: { VueSlider },

  data() {
    return {
      value: 0.0,
      topic: "",
      setValue: 0.0,
    };
  },

  mounted() {},
  watch: {
    config: {
      immediate: true,
      deep: true,
      handler() {
        setTimeout(() => {
          let variable = this.config.variable;
          if (this.$store.state.selectedDevice.ext_mqtt) {
            variable = this.config.variableFullName;
          }

          emitter.off(this.topic + "/sdata");

          this.topic =
            this.config.userId +
            "/" +
            this.config.selectedDevice.dId +
            "/" +
            variable;
          emitter.on(this.topic + "/sdata", this.procesReceivedData);
        }, 300);
      },
    },
  },

  beforeDestroy() {
    emitter.off(this.topic + "/sdata");
  },
  methods: {
    sendValue() {
      const toSend = {
        topic: this.topic + "/actdata",
        msg: {
          value: this.setValue,
        },
      };

      //console.log(toSend);
      emitter.emit("mqtt-sender", toSend);
    },
    procesReceivedData(data) {
      if (data == null) return;
      try {
        this.value = data.value;
      } catch (error) {
        console.log(error);
      }
    },

    getIconColorClass() {
      //para apagar el icono
      if (!this.value) {
        return "text-dark";
      }

      if (this.config.class == "success") {
        return "text-success";
      }
      if (this.config.class == "primary") {
        return "text-primary";
      }
      if (this.config.class == "warning") {
        return "text-warning";
      }
      if (this.config.class == "danger") {
        return "text-danger";
      }
    },

    updateColorClass() {
      //console.log("update" + this.config.class)

      var c = this.config.class;

      if (c == "success") {
        return "#7cae47";
      }
      if (c == "primary") {
        return "#4380dd";
      }
      if (c == "warning") {
        return "#e69f17";
      }
      if (c == "danger") {
        return "#e04f1a";
      }
    },

    getStep() {
      return 1 / Math.pow(10, this.config.decimalPlaces); // Retorna el step según la precisión deseada
    },

    // Función para dar formato al tooltip según decimalPlaces
    formatTooltip(value) {
      return value.toFixed(this.config.decimalPlaces);
    },
    procesReceivedData(data) {
      if (data == null) return;
      try {
        this.value = data.value;
        this.setValue = data.value;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
